import { useGetAccountQuery, useGetCurrentUserQuery } from "@/shared/services";
import { ScrollArea } from "@components/ui/scroll-area";
import { useAuthStoreShallow } from "@features/authentication";
import { PlatformOnboardingSidebar } from "@features/platform-onboarding/components/platform-onboarding-sidebar";
import { cn } from "@lib/cn";
import { useSidebarStore } from "../store";
import { SidebarBaseMenu } from "./sidebar-base-menu";
import { SidebarFooter } from "./sidebar-footer";
import { SidebarHeader } from "./sidebar-header";

export const Sidebar = () => {
  const isOpen = useSidebarStore((s) => s.isOpen);
  const { data: user } = useGetCurrentUserQuery();
  const { data: account } = useGetAccountQuery();
  const isUserOrCreatorLite = useAuthStoreShallow((s) => s.isUserOrCreatorLite);

  return (
    <div
      data-tour-dim-clear="sidebar"
      className={cn(
        "tw-sticky tw-top-0 tw-h-screen tw-w-[255px] tw-shrink-0 tw-overflow-hidden tw-border-r tw-border-blue-100 tw-bg-blue-50 tw-transition-[width] tw-duration-300 -xl:tw-hidden",
        !isOpen && "tw-w-12",
      )}
    >
      {/* The column is exactly the viewport and never grows the page. Only the
          menu scrolls; the column itself scrolls only on windows too short for
          the header, the bottom stack and a minimum of menu together. */}
      <div
        className={cn(
          "tw-invisible tw-flex tw-h-full tw-flex-col tw-overflow-y-auto tw-overflow-x-hidden tw-opacity-0 tw-transition-[opacity,visibility] tw-duration-300 tw-ease-linear",
          user && account && "tw-visible tw-opacity-100",
        )}
      >
        <SidebarHeader />
        <ScrollArea className="tw-min-h-32 tw-flex-1">
          <SidebarBaseMenu />
        </ScrollArea>
        <div className="tw-z-20 tw-shrink-0 tw-bg-blue-50">
          <PlatformOnboardingSidebar />
          {!isUserOrCreatorLite && <SidebarFooter />}
        </div>
      </div>
    </div>
  );
};
